// ============================================================================
// layer.batches.index — independently owned hub
// ============================================================================
// The exact no-suffix LayerBatchesHub reads its batch/housing directories and
// paginated layer/egg metrics through `layer.batches.core`.  The sibling record
// surfaces still receive App's legacy arrays through LayerBatchesRouter, but
// they are distinct surfaces and are never mounted by this released hub.
// Therefore their legacy ownership is not a residual dependency of this one.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'layer.batches.index',
  obligations: Object.freeze([
    Object.freeze({id: 'layer.batches.core', owner: 'permanent'}),
    Object.freeze({id: 'layer.eggDailys.groups', owner: 'permanent'}),
  ]),
  residualLegacy: Object.freeze([] as const),
});

export default declaration;
